// apps/web/src/features/call-center/IntakeLogoutButton.tsx
//
// Standalone logout control for the confined call-center intake page
// (#1259). The external agent has no ProfileMenu/AppShell, so logout is a
// plain button here. Mirrors the proven ProfileMenu logout flow exactly:
// `logout.mutate(... onSettled: clearWithBroadcast + navigate('/login'))`.
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useLogout } from '@magimp/shared-hooks';
import { Button } from '../../ui/index.js';
import { clearWithBroadcast } from '../../api/authEvents.js';

export function IntakeLogoutButton() {
  const { t } = useTranslation('callCenter');
  const navigate = useNavigate();
  const logout = useLogout();

  const onLogout = () => {
    logout.mutate(undefined, {
      onSettled: () => {
        clearWithBroadcast('LOGOUT');
        navigate('/login');
      },
    });
  };

  return (
    <Button kind="ghost" disabled={logout.isPending} onClick={onLogout}>
      {t('intake.logout')}
    </Button>
  );
}
